import React from 'react'

const IsProctoredContext = React.createContext({
  isProctored: '',
  setIsProctored: () => {},
})

export default IsProctoredContext
